import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as FlowDownstreamOwnersFilteredByFlowOutputFieldQuery
export const FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFields(filter: { id: $selectedFlowOutputFieldId }) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerIdFragment
        }
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
